<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <div class="form tw-text-center tw-ml-auto tw-w-full tw-px-5 lg:tw-px-12 tw-flex tw-flex-col tw-items-center tw-justify-center">
                <img src="~@/assets/img/icons/error.svg">
                <p class="tw-text-white tw-text-base tw-py-6">
                    Lamentamos, mas não cumpre os requisitos mínimos necessários para avançarmos com o pedido. Para mais esclarecimentos adicionais, por favor contacte-nos pelos meios alternativos: <b><u><a href="mailto:geral@goldfinance.pt">geral@goldfinance.pt</a></u></b> ou <b>218 282 815</b>.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {

}

</style>
